// @mui
import { List, Box, Typography, TypographyProps } from '@mui/material';
//
import { NavSectionProps } from '../type';
import NavList from './NavList';
import { styled } from "@mui/material/styles";

// ----------------------------------------------------------------------
const GroupTitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'active',
})<TypographyProps>(({ theme }) => ({
  position: 'relative',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(1.5),
  marginBottom: theme.spacing(0.5),
  paddingTop: theme.spacing(2),
  color: '#C2BFBF',
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.overline.fontSize,
}));


export default function NavSectionVertical({ navConfig, isCollapse, ...other }: NavSectionProps) {
  
  return (
    <Box {...other}>
      {navConfig.map((group, idx) => (
        <List key={idx} disablePadding>
          {group.title && !isCollapse &&
            <GroupTitle id={group?.id}>{group.title}</GroupTitle>
          }
          {group.items.map((list) => (
            <NavList
              key={list.title + list.path}
              data={list}
              depth={1}
              hasChildren={!!list.children}
              isCollapse={isCollapse}
            />
          ))}
        </List>
      ))}
    </Box>
  );
}
